import {AbstractViewerComponent} from "./abstract-viewer.component";
import {customElement} from "lit/decorators/custom-element.js";
import {PropertyValues} from "@lit/reactive-element";
import {html} from "lit";

@customElement('ha-rte-viewer')
export class HaRteViewerComponent extends AbstractViewerComponent<any> {

    protected shouldUpdate(_changedProperties: PropertyValues): boolean {
        return typeof this.value == "object" && super.shouldUpdate(_changedProperties);
    }

    protected render(): unknown {
        return html`
            <ha-quill-viewer .value=${this.value}></ha-quill-viewer>
        `;
    }
}